import "core-js/modules/web.dom.iterable";
import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";
import "core-js/modules/es6.number.constructor";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import CarUseDrawer from "./modules/CarUseDrawer";
import { JeecgListMixin } from '@/mixins/JeecgListMixin';
import { queryUserTreeList } from '@/api/api';
import { getAction } from '@api/manage';
import moment from 'moment';
export default {
  name: 'CarUseList',
  mixins: [JeecgListMixin],
  components: {
    CarUseDrawer: CarUseDrawer
  },
  data: function data() {
    return {
      permissionObj: {
        add: 'car:ea_asset_car_use:add',
        delete: 'car:ea_asset_car_use:delete',
        edit: 'car:ea_asset_car_use:edit',
        deleteBatch: 'car:ea_asset_car_use:deleteBatch'
      },
      time: true,
      carShow: true,
      pagePath: '/ea/asset/car/use',
      pageTitle: '车辆使用',
      userTree: [],
      //人员信息
      autoLoadInit: false,
      carList: [],
      model: [],
      //时间差
      userId: 1,
      // 表头
      columns: [{
        title: '序号',
        dataIndex: '',
        key: 'rowIndex',
        width: 60,
        align: 'center',
        customRender: function customRender(t, r, index) {
          return parseInt(index) + 1;
        }
      }, {
        dataIndex: 'card',
        colName: 'car_id',
        title: '车牌号',
        align: 'center'
      }, {
        dataIndex: 'userId_userName',
        colName: 'user_id',
        title: '借用人',
        align: 'center'
      }, {
        dataIndex: 'purpose',
        colName: 'purpose',
        title: '借车用途',
        align: 'center'
      }, {
        dataIndex: 'sdate',
        colName: 'sdate',
        title: '借用时间',
        align: 'center'
      }, {
        dataIndex: 'edate',
        colName: 'edate',
        title: '归还时间',
        align: 'center'
      }, {
        dataIndex: 'roadFee',
        colName: 'roadFee',
        title: '路费',
        align: 'center'
      }, {
        dataIndex: 'total',
        colName: 'total',
        title: '出车总公里数',
        align: 'center'
      }, {
        title: '操作',
        dataIndex: 'action',
        align: 'center',
        width: 150,
        scopedSlots: {
          customRender: 'action'
        }
      }],
      url: {
        carList: '/ea/asset/car/queryCarCards'
      },
      keys: [],
      roleList: '',
      addTime: '',
      buTime: '',
      siteName: '',
      queryParam: {
        column: 'create_time',
        order: 'desc'
      }
    };
  },
  props: {
    carId: {
      type: Number,
      default: null
    },
    carDetails: Boolean
  },
  created: function created() {
    if (this.carDetails) {
      this.queryParam.carId = this.carId;
      this.carShow = !this.carDetails;
    }

    this.loadTreeList();
    this.queryCarList();
    this.model = moment(new Date()).format('YYYY-MM-DD HH:mm:ss');
    this.keys = JSON.parse(window.localStorage.getItem('pro__Login_Userinfo'));

    if (!(this.$store.getters.userInfo.roleList.includes('administrator') || this.$store.getters.userInfo.roleList.includes('Finance'))) {
      this.queryParam.userId = this.keys.value.id;
    }

    this.loadData();
  },
  computed: {},
  methods: {
    moment: moment,
    onDateSdata: function onDateSdata(value, dateArray) {
      this.queryParam.stime = dateArray[0];
      this.queryParam.etime = dateArray[1];
    },
    // 用户树下拉
    loadTreeList: function loadTreeList() {
      var _this = this;

      var that = this;
      that.userTree = []; // 用户

      queryUserTreeList().then(function (res) {
        if (res.success) {
          for (var i = 0; i < res.result.length; i++) {
            var temp = res.result[i];
            that.userTree.push(temp);
          }

          _this.loading = false;
        }
      });
    },
    //查询
    searchQuery: function searchQuery() {
      if (this.$refs.page) {
        this.$refs.page.resetPage();
      } else {
        this.loadData(1);
      }
    },
    //车牌信息列表
    queryCarList: function queryCarList() {
      var that = this;
      that.carList = [];
      getAction(that.url.carList).then(function (res) {
        if (res.success) {
          that.carList = res.result;
        }
      });
    },
    searchReset: function searchReset() {
      this.queryParam = {
        carId: this.carId,
        column: 'create_time',
        order: 'desc'
      };

      if (!(this.$store.getters.userInfo.roleList.includes('administrator') || this.$store.getters.userInfo.roleList.includes('Finance'))) {
        this.queryParam.userId = this.keys.value.id;
      }

      this.dates = {};
      this.loadData(1);
    },
    handleAdd: function handleAdd() {
      if (this.carId != null) {
        this.$refs.modalForm.add(this.carId);
      } else {
        this.$refs.modalForm.add();
      }

      this.$refs.modalForm.title = '新增：' + this.pageTitle;
      this.$refs.modalForm.disableSubmit = false;
      this.$refs.modalForm.showTab = false;
      this.$refs.modalForm.showContact = false;
    },
    handleDetail: function handleDetail(record) {
      this.$refs.modalForm.edit(record);
      this.$refs.modalForm.title = this.pageTitle + '详情';
      this.$refs.modalForm.disableSubmit = true;
      this.$refs.modalForm.disableStatus = true;
      this.$refs.modalForm.showTab = true;
      this.$refs.modalForm.showContact = false;
    },
    handleEdit: function handleEdit(record) {
      this.$refs.modalForm.edit(record);
      this.$refs.modalForm.title = '编辑：' + this.pageTitle;
      this.$refs.modalForm.disableSubmit = false;

      if (this.carId != null) {
        this.$refs.modalForm.disableStatus = true;
      } else {
        this.$refs.modalForm.disableStatus = false;
      }

      this.$refs.modalForm.showTab = true;
      this.$refs.modalForm.showContact = true;
    },
    getAuth: function getAuth(id) {
      if (this.$store.getters.userInfo.roleList.includes('administrator') || this.$store.getters.userInfo.roleList.includes('tenant_admin')) {
        return true;
      } else {
        return id == this.$store.getters.userInfo.id && this.buTime - this.addTime < 60 * 60 * 1000;
      }
    },
    filterOption: function filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0;
    }
  }
};